<template>
  <Row :gutter="20">
    <Col :span="16">
    <BaseSegment title="平台数据" style="margin:20px;">
    <div class="flex-wrap flex-between" >
      <template v-for="(num,i) in nums">

      <BaseNumboard :name="num.name" style="width:120px" :value="num.count" :unit="num.unit" :key="'_num'+i" />
      </template>
      </div>
      </BaseSegment>
    </Col>
    <Col :span="8">
    <BaseSegment title="用户"  style="margin:20px;">
     <div class="flex-wrap flex-between">
    <template v-for="(num,i) in user_nums">

      <BaseNumboard :name="num.name" style="width:120px" :value="num.count" :unit="num.unit" :key="'_num'+i" />
      </template>
      </div>
      </BaseSegment>
    </Col>
  </Row>
</template>

<script>
export default {
  data() {
    return {
      nums: [{
        name: '一级类别',
        count: 0,
      }, {
        name: '二级类别',
        count: 0,
      }, {
        name: '三级类别',
        count: 0,
      }, {
        name: '产品',
        count: 0,
      }, {
        name: '品牌',
        count: 0,
      }, {
        name: '商家',
        count: 0,
      }, {
        name: '询价(LV1)',
        count: 0,
      }, {
        name: '询价(LV2)',
        count: 1,
      }, {
        name: '询价(LV3)',
        count: 2,
      }],
      user_nums: [{
        name: '本周访问',
        count: 32,
      }, {
        name: '本周上传',
        count: 12,
        unit: '条',
      }],
    };
  },
  mounted() {
    setTimeout(()=>{
      this.getData();
    }, 500);
  },
  methods: {
    getData() {
      this.$api.get('mat/counts?force=1').then((res)=>{
        const data = res.data.data;
        data.nums.forEach((v, i)=>{
          this.nums[i].count = v.count;
          this.nums[i].new_count = v.new_count;
        });
        data.user_nums.forEach((v, i)=>{
          this.user_nums[i].count = v.count;
          this.user_nums[i].new_count = v.new_count;
        });
      });
    },
  },
};
</script>

<style>

</style>
